import axios from '@/assets/js/axios.js'
import { BRAND_API } from './apis'
// 获取分组标签列表
export function brandList (params) {
  return axios({
    url: BRAND_API.QUERY,
    method: 'post',
    data: params
  })
}
// 获取引导页列表
export function addBrand (params) {
  return axios({
    url: BRAND_API.ADD,
    method: 'post',
    data: params
  })
}
// 启用/禁用
export function isUse (params) {
  return axios({
    url: BRAND_API.DISABLE,
    method: 'post',
    data: params
  })
}
// 删除
export function isDel (params) {
  return axios({
    url: BRAND_API.DELETE,
    method: 'post',
    data: params
  })
}
// 根据ID获取引导页详情
export function brandDetail (params) {
  return axios({
    url: BRAND_API.DETAIL,
    method: 'post',
    data: params
  })
}
// 更新
export function editBrand (params) {
  return axios({
    url: BRAND_API.UPDATE,
    method: 'post',
    data: params
  })
}
